export const bannedWallets = [
  "GCMDVONMCUMSU55WDUNUPJN7UMYDJFL2HBTQGAO7TUUUBARIPFBAPCN7",
  "GDG4OCQ5C4IVUTU2WXNCVBMLK7VOF3HOA54FEKQQJZYMMSNBPELKQ7OZ",
  "GDOQVIBYMAA3OBC4AYRPYITZWCSZUTC4NETXLTDUOPBGRZRQADGD5WUY",
  "GCDXEBIBQMCIH3TOFBJ2V3S4RFAY4KQGE7OJ72VZ7DTGATUBP56U6MJY",
  "GBATPKSCLNLAOJ2XN5S7FFYSIPAG4TKIFO6ZSZUB6A5PJFTGHMWQ2WAR",
  "GAUTCBFEUU3G4IB3FZTE2NLT4RTW4WOHFSSWBJIUWF2GYP5RZB6KDAI7",
  "GD7KWUM57KWO3JLSNPUQM7OU3HWX3RQJBVOD6VD4Z22Q5JPFIPBEMVJD",
  "GCONC7UPIBODLV4PFDQXMP6NBPTZMIWHD3IHPQBTVTEKPCVMJEKN6IAD",
  "GAL2CDJXHWG2ZAUKUUBG6XUHB3VODDZGVO6U5S4QLBXXH2DZXHVLF2HC",
  "GDMWMXL2Z7PM5WQZZZT4ZOTBWETGR7XKIVOQPBRON5U6MJWMAQTKOACM",
  "GB2QPRZ2VRI2SKYUYJMQ62FXNTXYI3Z7GXHTIVW7DTJFQF7XTOO64ERE",
  "GCMFM4T674TLFR4QDC3RP44ALYH2234JBST6GRUNJTYMKEDJHTZ7B3NY",
  "GDJKWTG3SAEUEX7YV2VI3DYXINLTEIX2FN6WHTKYBVLJ4VB4IGDP4G2M",
  "GA57QNMWKJA4KGVZEOBO76OGFFXO5JG3GOZGNEWZE52WWEHKE3MVOCZC",
  "GDCFYCOL7KOB7TRPGKYKMZVTZYDNN5SAWODFL44K5A62YJ2HMEZ6KMUT",
  "GALGKLCXVH7EA4P57JKEKTKT4EKJDSZKSHC4DPUYOTEPF6BT2J2EP6YY",
  "GB7LTFFGCNTOJOFSCH3YV5XYYL2MPJALPTGJ35MEDX6D22WZVW6AKS2M",
  "GCKGII44CS3BMIP4224VNKZLOREVMHZQV3CUMHGDV3KFRTDSNITUYMHN",
  "GCKG2NVXH47ULIHOEL3C6IFO3BR2SBV6VSIH5UDPJFJBTLG6PBWS6ZSL",
  "GBWYENME76Z7A5PUUIEXPFS2RAFIEGM4AINLZRT7WG445TYYUTIXFHLY",
  "GAOETBCZKVZBNVTL2X3SDM2XQEPNSEIIET2EWFIEMOWOMVEKJOOLM65F",
  "GDN75RTXUSS7Y3KBURNVO5C6XZ2SRHQ2N75JZHADMBOFSFIQLXK6TGLC",
  "GDVC2XSWXVXEB5LK3UMJUO4SAH4YET6SJ365XIUVZ7YBXFFOPKIEYUNE",
  "GAG3XUBA6IEZPMBP2O4JDEU2DHDBXHQCUXWVPU5I4D2557S6S62BOFNW",
  "GDROQXCXUIUCLENC4CIGGPUQUGBMO2IRH6VUXYPHTIHGJW6J3P2Y2QGT",
  "GAG3XUBA6IEZPMBP2O4JDEU2DHDBXHQCUXWVPU5I4D2557S6S62BOFNW",
  "GAG3XUBA6IEZPMBP2O4JDEU2DHDBXHQCUXWVPU5I4D2557S6S62BOFNW",
];
